import { useAuth } from '@chainlit/react-client';
import { Translator } from 'components/i18n';
import { AlertCircle } from 'lucide-react';

export default function AnonymousBanner() {
  const { data, user } = useAuth();

  if (!data?.allowAnonymous || user) {
    return null;
  }

  const getLoginHref = () => {
    if (data?.loginRedirectUrl) {
      return data.loginRedirectUrl;
    }
    if (!data?.passwordAuth && data?.oauthProviders?.length === 1) {
      return `/auth/oauth/${data.oauthProviders[0]}`;
    }
    return '/login';
  };

  return (
    <div
      className="bg-primary text-background p-2 px-4 flex items-center justify-between text-sm animate-in fade-in slide-in-from-top-2 duration-500"
      role="alert"
    >
      <div className="flex items-center">
        <AlertCircle className="mr-2" />
        <p>
          <Translator path="anonymous.banner.message" />
        </p>
      </div>
      <a
        href={getLoginHref()}
        className="ml-4 font-bold underline hover:text-orange-900 transition-colors"
      >
        <Translator path="anonymous.banner.login" />
      </a>
    </div>
  );
}
